export class InfoPopup {
  constructor (settings = {}) {
    this.options = $.extend({
      selectors: {
        container: '.info-popup',
        containerOpen: '.info-popup.info-popup--open',
        popup: '.info-popup__popup',
        pageHeader: '.page-header'
      },
      classes: {
        open: 'info-popup--open',
        popupTop: 'info-popup__popup--top',
        popupRight: 'info-popup__popup--right',
        popupBottom: 'info-popup__popup--bottom',
        popupLeft: 'info-popup__popup--left',
        close: 'info-popup__close',
        bodyHeaderScrolling: 'is--header-scrolling'
      },
      additionalOffsetTop: 10
    },
    settings)

    this.$body = $('body')
    this.$container = $(this.options.selectors.container)
  }

  init () {
    this.addEvents()
  }

  addEvents () {
    const that = this

    this.$body
      .on({
        click: function (event) {
          const clickElement = $(event.target)

          if (clickElement.closest(that.options.selectors.container).length === 0 || clickElement.hasClass(that.options.classes.close)) {
            that.closeAllPopups()
          }
        }
      })

    this.$container
      .on({
        click: function (event) {
          const element = $(event.target)

          if (element.closest(that.options.selectors.popup).length === 0) {
            that.closeAllPopups($(this))

            $(this)
              .toggleClass(that.options.classes.open)

            that.setDirection()
          }
        }
      })
  }

  closeAllPopups (exceptionElement) {
    const that = this

    if (exceptionElement) {
      $(that.options.selectors.container)
        .not(exceptionElement)
        .removeClass(that.options.classes.open)
    } else {
      $(that.options.selectors.container)
        .removeClass(that.options.classes.open)
    }
  }

  setDirection () {
    const that = this
    const containerOpen = $(that.options.selectors.containerOpen)

    if (containerOpen.length > 0) {
      const popup = containerOpen.find(that.options.selectors.popup)

      if (!popup.hasClass(that.options.classes.popupTop) &&
          !popup.hasClass(that.options.classes.popupRight) &&
          !popup.hasClass(that.options.classes.popupBottom) &&
          !popup.hasClass(that.options.classes.popupLeft)) {
        popup
          .addClass(that.options.classes.popupTop)
      }

      if (!that.checkOffsets(popup)) {
        // Try bottom
        popup
          .removeClass(that.options.classes.popupTop)
          .removeClass(that.options.classes.popupRight)
          .removeClass(that.options.classes.popupLeft)
          .addClass(that.options.classes.popupBottom)

        if (!that.checkOffsets(popup)) {
          // Try right
          popup
            .removeClass(that.options.classes.popupTop)
            .removeClass(that.options.classes.popupBottom)
            .removeClass(that.options.classes.popupLeft)
            .addClass(that.options.classes.popupRight)

          if (!that.checkOffsets(popup)) {
            // Try left
            popup
              .removeClass(that.options.classes.popupTop)
              .removeClass(that.options.classes.popupRight)
              .removeClass(that.options.classes.popupBottom)
              .addClass(that.options.classes.popupLeft)

            if (!that.checkOffsets(popup)) {
              // Try top
              popup
                .removeClass(that.options.classes.popupRight)
                .removeClass(that.options.classes.popupBottom)
                .removeClass(that.options.classes.popupLeft)
                .addClass(that.options.classes.popupTop)

              if (!that.checkOffsets(popup)) {
                // remove all orientation and center
                popup
                  .removeClass(that.options.classes.popupTop)
                  .removeClass(that.options.classes.popupRight)
                  .removeClass(that.options.classes.popupBottom)
                  .removeClass(that.options.classes.popupLeft)
              }
            }
          }
        }
      }
    }
  }

  checkOffsets (element) {
    const elementOffset = element.offset()
    const elementTopOffset = elementOffset.top
    const elementBottomOffset = elementTopOffset + element.outerHeight()
    const elementLeftOffset = elementOffset.left
    const elementRightOffset = elementLeftOffset + element.outerWidth()
    const ScreenTopOffset = $(document).scrollTop()
    const ScreenBottomOffset = ScreenTopOffset + $(window).height()

    if (elementTopOffset < (ScreenTopOffset + this.calculateHeaderOffset()) ||
        elementLeftOffset < 0 ||
        elementRightOffset > $(window).width() ||
        elementBottomOffset > ScreenBottomOffset) {
      return false
    }

    return true
  }

  calculateHeaderOffset () {
    const that = this

    if ($('body').hasClass(that.options.classes.bodyHeaderScrolling)) {
      return $(that.options.selectors.pageHeader).outerHeight() + that.options.additionalOffsetTop
    }

    return 0
  }
}

export default InfoPopup
